export default "__VITE_ASSET__9278a8dc__"